import { COOKIES, MonthInMs } from "constants/enum";

export const storeGclid = (gclid: string) => {
    const expiresDate = new Date(Date.now() + 3 * MonthInMs);

    document.cookie = `${
        COOKIES.GCLID_SERVICE_COOKIE
    }=${gclid};path=/;expires=${expiresDate.toUTCString()}`;
};
